import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const WaistCircumferenceHistoryPage = lazy(
  () => import("./WaistCircumferenceHistoryPage"),
);

const WaistCircumferenceHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <WaistCircumferenceHistoryPage />
    </Suspense>
  );
};

export default WaistCircumferenceHistoryPageLazy;
